import _ from 'lodash';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromLayout from './layout.reducer';

export const selectLayoutState = createFeatureSelector<fromLayout.State>(
  fromLayout.layoutFeatureKey
);

export const selectActivityLayoutHeight = createSelector(
  selectLayoutState,
  (state) => {
    const { entities: { header, status, live } } = state;
    const result = _.get(header, 'boundingClientRect.height', 0)
      + _.get(status, 'boundingClientRect.height', 0)
      + _.get(live, 'boundingClientRect.height', 0);
    let minus = 0;
    switch(state.resolution) {
      case 'xs':
      case 'sm':
      case 'md':
        minus = 80;
        break;
      case 'lg':
      case 'xl':
        minus = 113;
    }
    return window.innerHeight - result - minus;
  }
);

export const selectAuctioneerLayoutHeight = createSelector(
  selectLayoutState,
  (state) => {
    const { entities: { header, status, live } } = state;
    const result = _.get(header, 'boundingClientRect.height', 0)
      + _.get(status, 'boundingClientRect.height', 0)
      + _.get(live, 'boundingClientRect.height', 0);
    return window.innerHeight - result;
  }
);

export const selectPlaylistLayoutHeight = createSelector(
  selectLayoutState,
  (state) => {
    const { entities: { header, status, live, activity } } = state;
    const liveHeight = _.get(live, 'boundingClientRect.height', 0);
    const activityHeight = _.get(activity, 'boundingClientRect.height', 0);
    const result = _.get(header, 'boundingClientRect.height', 0)
      + _.get(status, 'boundingClientRect.height', 0)
    let minus = 0;
    switch(state.resolution) {
      case 'xs':
      case 'sm':
      case 'md':
        minus = 120;
        break;
      case 'lg':
        minus = 134;
        break;
      case 'xl':
        minus = 138;
        break;
    }
    let plus = 0;
    switch(state.resolution) {
      case 'xs':
      case 'sm':
      case 'md':
        plus = 8;
        break;
      case 'lg':
      case 'xl':
        plus = 20;
        break;
    }
    if(window.innerHeight - result < liveHeight + activityHeight + plus) {
      return liveHeight + activityHeight - minus + plus;
    } else {
      return window.innerHeight - result - minus;
    }
  }
);
